export default {
	app: {
		brand_zh: 'Ulucu',
		brand_en: 'ULUCU',
	},
	common: {
		todo_module: 'Módulo aún no implementado, en desarrollo',
		loading: 'Cargando…',
		no_data: 'Sin datos',
		select_store: 'Seleccionar tienda',
		show_raw: 'Ver respuesta cruda',
		reload: 'Recargar',
		filter: 'Filtrar',
		cancel: 'Cancelar',
		back: 'Volver',
	},
	group: {
		core: 'Núcleo',
		major: 'Principal',
		support: 'Soporte',
		value_add: 'Extras',
	},
	tabbar: {
		monitor: 'Monitoreo',
		home: 'Inicio',
		store: 'Tienda',
		application: 'Aplicaciones',
		incidents: 'Incidencias',
		analytics: 'Analítica',
		operations: 'Operación',
		account: 'Cuenta',
		video: 'Vídeo',
		reports: 'Informes',
		workbench: 'Tareas',
		messages: 'Mensajes',
		profile: 'Yo',
		messages_title: 'Centro de mensajes',
		reports_title: 'Análisis de clientes',
	},
	ops: {
		title: 'Operación',
		subtitle: 'Rondas, inspección IA y flujos de dispositivos',
		available: 'Disponible',
		permission_required: 'Requiere configuración',
		empty: 'Sin herramientas disponibles',
		view_status: 'Ver estado',
	},
	capability: {
		available_short: 'Disponible en esta región',
		permission_required_short: 'Requiere habilitación',
		unknown_short: 'API por confirmar',
		region_unavailable_short: 'No disponible en esta región',
		permission_required_desc: 'Esta cuenta no tiene permiso para usar este módulo. Mensaje nativo: You do not have the right to this module.',
		unknown_desc: 'Esta función para APAC/México necesita verificación de API antes de estar visible para usuarios.',
		region_unavailable_desc: 'Esta función pertenece al despliegue de China y no debe mostrarse en APAC/México.',
		back_to_operations: 'Volver a Operación',
	},
	root: {
		monitor: {
			subtitle: 'Vídeo de tiendas, estado de dispositivos y vista múltiple',
			store_count: 'Tiendas',
			online_devices: 'Dispositivos en línea',
			offline_devices: 'Sin conexión',
			favorites: 'Favoritos',
			tools: 'Herramientas de monitoreo',
			stores: 'Tiendas y canales',
			offline_action: 'Ver tiendas sin conexión',
			offline_filter_active: 'Filtrando sin conexión',
			tool_store: 'Gestión de tiendas',
			tool_store_hint: 'Revisar datos, grupos y estado operativo',
			tool_device: 'Estado de dispositivos',
			tool_device_hint: 'Revisar conexión, desconexión y canales',
			tool_multi_view: 'Vista múltiple',
			tool_multi_view_hint: 'Elegir una tienda antes de abrir vista multicanal',
			tool_multi_view_empty: 'No hay tiendas disponibles',
			multi_view_select_store: 'Elegir tienda',
			multi_view_store_count: '{{online}}/{{total}} en línea',
			multi_view_no_online: 'Sin canales en línea',
		},
		analytics: {
			subtitle: 'Tráfico, miembros, vehículos e indicadores de negocio',
			visible_modules: 'Módulos visibles',
			primary_period: 'Periodo principal',
			trend_period: 'Periodo de tendencia',
			currency: 'Moneda',
			tools: 'Herramientas de analítica',
			insights: 'Resumen de insights',
		},
		incidents: {
			subtitle: 'Incidencias pendientes, alertas y mensajes de tienda',
			pending: 'Pendientes',
			pending_hint: 'Requieren seguimiento',
			today: 'Incidencias de hoy',
			today_hint: 'Total del día',
			alerts: 'Alertas',
			alerts_hint: 'Riesgo y anomalías',
			visible_types: 'Tipos de mensaje',
			unread: 'Sin leer',
			loaded: 'Cargados',
			status: 'Estado',
			live: 'En vivo',
			tools: 'Herramientas de incidencias',
			workflow: 'Acciones principales',
			status_overview: 'Estado de incidencias',
			recent_messages: 'Mensajes recientes',
			inbox: 'Bandeja de incidencias',
			action_event: 'Gestionar incidencias',
			action_event_hint: 'Revisar pendientes, apelaciones y reinspección',
			action_alert: 'Ver alertas',
			action_alert_hint: 'Ubicar tiendas con anomalías y riesgo',
			action_message: 'Centro de mensajes',
			action_message_hint: 'Ver avisos, sistema y notificaciones',
			refresh: 'Actualizar resumen',
			updated_at: 'Actualizado a las {{time}}',
			not_updated: 'Sin actualizar',
			partial_data: 'Parte de los datos no está disponible',
			message_load_failed: 'No se pudieron cargar los mensajes',
			message_empty: 'No hay mensajes en esta categoría',
		},
		account: {
			subtitle: 'Organización, región, idioma y soporte',
			region: 'Región',
			language: 'Idioma',
			recent_count: 'Vistos recientemente',
			support_count: 'Accesos de soporte',
			profile: 'Perfil',
			preferences: 'Región e idioma',
			profile_hint: 'Nombre, teléfono, correo y avatar',
			language_hint: 'Chino / Español México',
			activity: 'Actividad',
			support: 'Soporte',
		},
	},
	wb: {
		evaluation: 'Evaluación',
		free_patrol: 'Patrulla libre',
		self_inspect: 'Auto-inspección',
		timed_check: 'Inspección programada',
		ai_patrol: 'Patrulla IA',
		report_audit: 'Auditoría',
		workorder: 'Orden de trabajo',
		reward: 'Premios',
		custom: 'Personalizar',
		customize: 'Personalizar',
		saved: 'Guardado',
		saved_local_only: 'Guardado localmente (error de sync)',
		locked: 'Bloqueado',
		self_check: 'Auto-verif.',
		cust_analysis: 'Clientes',
		heatmap: 'Mapa calor',
		apparel: 'Ropa',
		flow_alert: 'Alerta',
		member_id: 'Miembros',
		open_store: 'Nueva tienda',
		announce: 'Aviso',
		task: 'Tareas',
		report_in: 'Reporte',
		staff: 'Personal',
		cert: 'Certificados',
		university: 'Academia',
		huiting: 'Huiting',
		store_data: 'Datos',
		pic_detect: 'Detec. img.',
		cat: {
			patrol: 'Patrullaje',
			customer: 'Tráfico',
			enterprise: 'Negocio',
			other: 'Otros',
		},
		editor: {
			title: 'Gestionar apps',
			cancel: 'Cancelar',
			ok: 'Listo',
			hint: 'Arrastra para reordenar',
			shown: 'Apps de inicio',
		},
	},
	store_video: {
		tab_video: 'Video de tienda',
		tab_data: 'Datos de tienda',
		store_data_unavailable: 'Los datos de tienda se replicaran por separado. Esta pagina solo cubre el video de tienda.',
		organization: 'Organizacion',
		organization_all: 'Todas las organizaciones',
		organization_empty: 'Sin datos de organizacion',
		organization_failed: 'Filtro de organizacion no disponible: {{reason}}',
		organization_store_count: '{{count}} tiendas',
		filter: 'Filtro',
		search: 'Buscar',
		search_placeholder: 'Buscar tienda por nombre o codigo',
		favorite_only: 'Solo favoritos',
		summary_one: '{{count}} tienda en total, tasa en linea {{rate}}',
		summary: '{{count}} tiendas en total, tasa en linea {{rate}}',
		offline_count: 'sin conexion {{count}}',
		online_count: 'en linea {{count}}',
		total_count: 'total {{count}}',
		created_at: 'Fecha de creacion de la tienda',
		open_multi_view: 'Abrir vista multiple',
		sort_title: 'Ordenar',
		sort_default: 'Predeterminado',
		sort_default_ranking: 'Ranking predeterminado',
		sort_high_to_low: 'De mayor a menor',
		sort_low_to_high: 'De menor a mayor',
		sort_offline: 'Sin conexion primero',
		sort_create: 'Fecha de creacion',
		sort_name: 'Nombre de tienda',
		favorite_store_video: 'Video de tiendas favoritas',
		favorite_store_data: 'Datos de tiendas favoritas',
		no_collection: 'Sin favoritos',
		filter_data: 'Datos',
		filter_time: 'Tiempo',
		metric_entry_number: 'Numero de entradas',
		metric_total_number: 'Numero total',
		metric_total_sales: 'Ventas totales',
		metric_ecr: 'ECR',
		metric_events: 'Eventos',
		metric_turnover_rate: 'Tasa de conversion',
		time_today: 'Hoy',
		time_yesterday: 'Ayer',
		time_week: 'Esta semana',
		time_seven: 'Ultimos 7 dias',
		time_month: 'Este mes',
		time_thirty: 'Ultimos 30 dias',
		calling_store_manager: 'Llamando al encargado de la tienda',
	},
	settings: {
		account: 'Cuenta e idioma',
		app: 'Informacion de la app',
		storage: 'Almacenamiento local',
		support: 'Soporte',
		runtime: 'Entorno',
		runtime_app: 'App movil',
		runtime_web: 'Navegador web',
		version: 'Version',
		version_hint: 'Version actual del paquete web',
		clear_recent: 'Borrar vistos recientes',
		clear_recent_hint: '{{count}} registros locales',
		clear_recent_success: 'Vistos recientes borrados',
		feedback_hint: 'Enviar sugerencia o queja',
		hotline_hint: 'Ver opciones de soporte regional',
		logout: 'Cerrar sesion',
	},
	mtab: {
		video: {
			brand_full: 'Shanghai Ulucu Electronic Technology Co., Ltd.',
			search_placeholder: 'Buscar tienda por nombre o código',
			filter: 'Filtrar',
			tab_all: 'Todas',
			tab_fav: 'Favoritas',
			summary_one: '{{count}} tienda · Tasa de conexión: {{rate}}',
			summary: '{{count}} tiendas · Tasa de conexión: {{rate}}',
			offline_count_one: '{{n}} dispositivo sin conexión',
			offline_count: '{{n}} dispositivos sin conexión',
			device_online: 'En línea',
			device_offline: 'Sin conexión',
			all_online: 'Todos en línea',
			no_device: 'Sin dispositivos',
			view_all: 'Ver todo',
		},
		msg: {
			system: 'Sistema',
			event: 'Eventos',
			examine: 'Inspecciones',
			critical: 'Visitantes clave',
			empty: 'Sin mensajes en los últimos 2 días',
		},
		profile: {
			guest: 'No conectado',
			subtitle: 'Cuenta de demostración',
			album: 'Mi álbum',
			recent: 'Vistos recientemente',
			repair: 'Reparación online',
			repair_log: 'Historial de reparaciones',
			hotline: 'Línea de ayuda',
			feedback: 'Sugerencias',
			changelog: 'Novedades',
			settings: 'Ajustes',
			settings_hint: 'Idioma, version, almacenamiento y cierre de sesion',
			recent_empty: 'Sin registros recientes',
			recent_view_all: 'Ver todo',
			edit_profile: 'Perfil',
			edit_personal_data: 'Editar datos personales',
			name: 'Nombre',
			mobile: 'Teléfono',
			mobile_phone: 'Teléfono móvil',
			email: 'Correo electrónico',
			email_address: 'Dirección de correo electrónico',
			email_placeholder: 'Introducir contenido',
			edit_avatar: 'Editar avatar',
			save: 'Guardar',
			save_success: 'Guardado',
			save_unavailable: 'Guardar aún no disponible',
			online: 'En línea',
			offline: 'Desconectado',
			hotline_label: 'Línea de atención al cliente',
			call: 'Llamar',
			feedback_placeholder: 'Introduzca su sugerencia o comentario…',
			feedback_submit: 'Enviar',
			feedback_required: 'Contenido obligatorio',
			feedback_success: 'Gracias por sus comentarios',
			changelog_empty: 'Sin novedades aún',
		},
		rep: {
			pos_input: 'Entrada POS',
			portrait: 'Perfil',
			precise: 'Flujo preciso',
			batch: 'Flujo por lotes',
			realtime: 'Tiempo real',
			consume: 'Gasto',
			distribution: 'Distribución',
			funnel: 'Embudo',
			duration: 'Tiempo de estancia',
			rank: 'Ranking tiendas',
			store_filter: '{{count}} tienda(s) seleccionada(s)',
			overview: 'Resumen',
			mom: 'MoM',
			yoy: 'YoY',
			compare_range: 'Periodo comparado',
			pass_count: 'Pasos cercanos',
			enter_count: 'Entradas',
			enter_conv: 'Tasa de entrada',
			try_count: 'Pruebas',
			try_conv: 'Tasa prueba',
			member_count: 'Miembros',
			stay_duration: 'Estancia media (min)',
			deal_conv: 'Tasa cierre',
			leave_count: 'Salidas',
			invoice_count: 'Transacciones',
			amount: 'Ingresos',
			commodity_count: 'Artículos',
			avg_enter: 'Entradas medias',
			hour: 'Hora',
			day: 'Día',
			flow_trend: 'Tendencia de flujo',
			daily_avg: 'Media diaria',
			peak: 'Máximo',
			valley: 'Mínimo',
		},
	},
	player: {
		playback: 'Reproduccion',
		history_segment_count: '{{count}} segmentos',
		hd: 'HD',
		sd: 'SD',
		fill: 'Llenar',
		fit: 'Ajustar',
		live: 'En vivo',
		all: 'Todo',
		view_legend: 'Leyenda',
		no_device: 'Selecciona un dispositivo',
		no_stream: 'Sin transmisión',
		no_history: 'Sin grabación este día',
		no_record_at_time: 'Sin grabación en este momento',
		playback_started: 'Reproducción iniciada',
		screenshot_done: 'Captura guardada',
		fn_screenshot: 'Captura',
		fn_intercom: 'Intercomunicador',
		fn_record: 'Grabar',
		fn_event: 'Nuevo evento',
		fn_ptz: 'PTZ',
		fn_pos: 'Búsqueda POS',
		fn_record_stop: 'Detener grabación',
		recording_started: 'Grabando…',
		recording_saved: 'Grabación guardada',
		cap_unsupported: 'No compatible con este dispositivo',
		share: 'Compartir',
		video_init_failed: 'No se pudo inicializar el video...',
	},
	ptz: {
		no_permission: 'Sin permiso PTZ. Pide al administrador habilitarlo en la consola ulucu.',
	},
	rename: {
		title: 'Renombrar canal',
		placeholder: 'Nuevo alias',
		success: 'Renombrado',
		failed: 'Error al renombrar',
	},
	channel: {
		select: 'Seleccionar canal',
		count: '{{count}} canales',
	},
	store_detail: {
		tab_devices: 'Dispositivos',
		tab_overview: 'Resumen',
		copy: 'Copiar',
		copied: 'Copiado',
		copy_failed: 'Error al copiar',
		created_at: 'Creada',
		devices_all: 'Todos',
		devices_online: 'En línea',
		devices_offline: 'Sin conexión',
		cat_all: 'Todos los dispositivos',
		cat_camera: 'Cámaras',
		cat_audio: 'Audio',
		my_nvr_devices: 'Mis NVR',
		multi_view: 'Vista múltiple',
		open_video: 'Abrir vídeo',
		more: 'Más',
		status_online: 'En línea',
		status_offline: 'Sin conexión',
		offline_hint: 'Dispositivo sin conexión; reproducción no disponible',
		offline_unplayable: 'Dispositivo sin conexión; reproducción no disponible',
		call_owner: 'Llamar al dueño',
		no_phone: 'Esta tienda no tiene teléfono',
		repair_log: 'Historial de reparaciones',
		service_hotline: 'Línea de soporte',
		delete_store: 'Eliminar tienda',
		confirm_delete: '¿Eliminar esta tienda?',
		confirm_delete_ok: 'Eliminar',
		deleted: 'Eliminada',
		delete_failed: 'Error al eliminar',
	},
	repair: {
		title: 'Reparación online',
		store: 'Tienda',
		contact: 'Contacto',
		contact_phone: 'Teléfono',
		store_phone: 'Teléfono tienda',
		describe: 'Descripción',
		optional: 'Opcional',
		add_images: 'Añadir imágenes',
		images_tip: 'Sube imágenes que ilustren el problema para resolverlo más rápido.',
		tip: 'Para resolución más rápida, intenta primero la solución local antes de reportar.',
		submit: 'Enviar',
		contact_required: 'Nombre requerido',
		phone_required: 'Teléfono requerido',
		describe_required: 'Descripción requerida',
		success: 'Enviado',
		failed: 'Error al enviar',
		over_limit: 'Esta tienda alcanzo el limite de reparaciones pendientes. Procesa los registros existentes antes de enviar otro.',
		history: 'Historial',
	},
	hotline: {
		cn_desc: 'Las cuentas de China pueden llamar directamente a la línea de atención.',
		local_label: 'Soporte local',
		local_value: 'APAC / México',
		local_desc: 'Los usuarios de México y APAC no deben usar la línea 400 de China. Envía una solicitud de soporte o contacta a tu ejecutivo local.',
		feedback_action: 'Enviar solicitud',
	},
	inspect: {
		status: 'Estado',
		overdue: 'Vencido',
		progress: 'Progreso',
	},
	patrol: {
		total_plans: 'Total de planes',
		completed: 'Completados',
		overdue: 'Vencidos',
		completion_rate: 'Tasa de finalización',
	},
	message: {
		unread_by_category: 'No leídos por categoría',
		unread: 'No leído',
		recent: 'Mensajes recientes',
		cat_all: 'Todos',
		cat_event: 'Evento',
		cat_alarm: 'Alarma',
		cat_examine: 'Inspección',
		cat_system: 'Sistema',
		cat_share: 'Compartir',
		cat_face: 'Reconocimiento facial',
		cat_human_alarm: 'Alarma humana',
		cat_shop_inspection: 'Inspección de tienda',
		cat_detachment_detection: 'Detección fuera de puesto',
		cat_spot_inspection: 'Tarea de inspección',
		cat_black_list: 'Lista negra',
		cat_youxun_moveai: 'Youxun IA móvil',
		cat_youxun_picai: 'Youxun IA de imagen',
		cat_pos_trade: 'Transacción POS',
		cat_youqin: 'Asistencia Youqin',
		cat_face_mask: 'Reconocimiento de mascarilla',
		cat_data_warning: 'Alerta de datos',
		cat_take_place: 'Disparador de evento',
		cat_youxun_advancedai: 'Youxun IA avanzada',
		cat_youxun_paidui: 'Fila Youxun',
		cat_shelf_analysis: 'Análisis de estantes',
	},
	alert: {
		total: 'Total de alertas',
		pending: 'Pendientes',
		handled: 'Atendidas',
	},
	incident_domain: {
		title: 'Mesa de incidencias',
		subtitle: 'Atiende eventos, alertas y mensajes en un solo lugar',
		partial_data: 'Algunos datos de incidencias no están disponibles',
		alert_unread: 'Alertas sin leer',
		message_unread: 'Mensajes sin leer',
		status_overview: 'Resumen de estado',
		alert_workbench: 'Atención de alertas',
		alert_note: 'Las estadísticas de alertas ya están conectadas',
		alert_note_desc: 'El detalle de alertas requiere confirmar el diccionario de tipos de evento. Por ahora usa el estado de eventos y mensajes de alerta para ubicar riesgos pendientes.',
		message_workbench: 'Atención de mensajes',
		no_messages: 'No hay mensajes en esta categoría',
		event_message_hint: '{{count}} mensajes de evento siguen sin leer. Cambia a Mensajes para atenderlos.',
	},
	store: {
		all_stores: 'Todas las tiendas',
		groups: 'Grupos de tiendas',
		total: 'Total de tiendas',
		online: 'Abierto',
		with_device: 'Con dispositivo',
		has_device: 'Con dispositivo',
		stores_in_group: 'tiendas',
	},
	heatmap: {
		todo_visualization: 'Visualización de mapa de calor pendiente',
		todo_desc: 'Datos crudos obtenidos (abajo). Se renderizará con ECharts heatmap.',
	},
	msg: {
		order_title: 'Reordenar tipos',
		save: 'Guardar',
		saved: 'Guardado',
		available: 'Tipos disponibles',
		no_more: '— No hay más —',
		row_label: '{{label}}, posición {{position}} de {{total}}',
		remove_label: 'Quitar {{label}}',
		add_label: 'Añadir {{label}}',
		move_up_label: 'Subir {{label}}',
		move_down_label: 'Bajar {{label}}',
		unread_card_label: 'Mensaje no leído: {{title}}',
		status: { unread: 'No leído' },
		kp: {
			arrive_time: 'Hora de llegada',
			store: 'Tienda',
			name: 'Nombre',
			sex: 'Género',
			male: 'Hombre',
			female: 'Mujer',
			record: 'Registro',
			arrive_n_times: 'Visitas: {{n}}',
		},
		pos: {
			fallback: 'Transacción',
			type_1: 'Venta',
			type_2: 'Reembolso',
			type_3: 'Recarga',
			type_4: 'Pérdida',
			type_5: 'Redondeo',
			type_6: 'Anomalía IA',
			type_7: 'Corrección',
			type_8: 'Devolución',
			type_9: 'Anulación',
			type_10: 'Descuento',
			type_11: 'Reemb. delivery',
			type_12: 'Pedido rechaz.',
			type_13: 'Cancel. anómala',
			type_14: 'Devol. anómala',
			type_15: 'Cortesía',
		},
	},
	msg_t: {
		system: 'Sistema',
		event: 'Eventos',
		examine: 'Evaluación',
		key_person: 'Visitas clave',
		blacklist: 'Lista negra',
		xundian: 'Patrulla',
		tuogang: 'Ausencia',
		pic_ai: 'IA imagen',
		move_ai: 'IA vídeo',
		face_mask: 'Sin mascarilla',
		data_warn: 'Alerta datos',
		cert: 'Certificados',
		youschool: 'Academia',
		store_build: 'Nueva tienda',
		image_exception: 'Imagen rota',
		alarm: 'Alarma',
		human_alarm: 'Alerta humana',
		face: 'Cara',
		ai_tag_video: 'Vídeo IA',
		pos_trade: 'POS',
		dianjian: 'Inspección',
	},
	eval: {
		search_ph: 'Buscar tareas',
		expired_tasks: 'Caducadas',
		no_active: 'Sin tareas activas',
		no_expired: 'Sin tareas caducadas',
		valid_time: 'Vigencia',
		to: 'a',
		cycle: 'Ciclo',
		frequency: 'Frecuencia',
		times: 'veces',
		eval_stores: 'Tiendas',
		done_stores: 'Hechas',
		unit_store: '',
		unit_copy: 'uds',
		progress: 'Progreso',
		submit_count: 'Enviadas',
		remote_eval: 'Remoto',
		onsite_eval: 'Presencial',
		view_report: 'Informes',
		detail_title: 'Detalle',
		template: 'Plantilla',
		evaluators: 'Evaluadores',
		recent_reports: 'Informes recientes',
	},
	rp: {
		tab_records: 'Registros',
		tab_levels: 'Reglas',
		all_rp: 'Todo',
		reward: 'Premio',
		penalty: 'Sanción',
		last_7d: 'Últimos 7 días',
		last_30d: 'Últimos 30 días',
		last_90d: 'Últimos 3 meses',
		sort_by_create: 'Por fecha',
		add: 'Añadir',
		edit: 'Editar',
		delete: 'Eliminar',
		confirm_delete: '¿Eliminar esta regla?',
		deleted: 'Eliminada',
		delete_failed: 'Error al eliminar',
		edit_title: 'Editar regla',
		add_title: 'Nueva regla',
		save: 'Guardar',
		saved: 'Guardado',
		save_failed: 'Error al guardar',
		type: 'Tipo',
		level_name: 'Nombre',
		level_name_ph: 'Nombre de la regla',
		amount: 'Importe',
		amount_ph: 'Ingresa el importe',
		usage: 'Uso',
		usage_ph: 'Describe el uso',
		title_required: 'Nombre requerido',
		amount_required: 'Importe válido requerido',
	},
	hot: {
		select_store: 'Tienda:',
		date: 'Fecha:',
		pick_store: 'Selecciona una tienda',
		no_device: 'Sin dispositivos',
		not_configured: 'Sin zonas configuradas',
		filter_areas: 'Filtrar zonas',
		show_all: 'Mostrar todo',
		hide_all: 'Ocultar todo',
		stay_label: 'Umbral:',
		seconds: '{{n}}s',
		keliu: 'Visitantes',
		stop: 'Detenidos',
		stop_rate: 'Tasa',
		avg_stay: 'Estancia',
	},
	traffic: {
		total_vehicles: 'Total de vehículos',
		avg_plate: 'Reconocimiento medio de matrículas',
		hourly_trend: 'Tendencia horaria de vehículos',
	},
	leavepost: {
		no_records: 'Sin registros de fuera del puesto este día',
		duration: 'Duración',
	},
	auth: {
		login_title: 'Iniciar sesión',
		account: 'Cuenta',
		account_required: 'Por favor ingrese su cuenta',
		password: 'Contraseña',
		password_required: 'Por favor ingrese su contraseña',
		login: 'Iniciar sesión',
		login_success: 'Sesión iniciada',
		login_failed: 'Error al iniciar sesión',
		session_elsewhere: 'It is detected that your account has been logged in elsewhere. Please sign in again.',
		remember_account: 'Recordar cuenta',
		logout: 'Cerrar sesión',
		logged_in_as: 'Sesión iniciada como',
		tip_internal_dev: 'Modo desarrollo — llamando API interna de ulucu (cambiará a plataforma abierta cuando se emitan las credenciales)',
	},
	home: {
		welcome: 'Bienvenido a Ulucu',
		intro: 'Cliente de gestión de tiendas · multilingüe (zh / en / es / ar)',
		store_count: '{{count}} tiendas en total',
		has_device: 'tiene dispositivo',
	},
	dashboard: {
		online_rate: 'Tasa de dispositivos en línea',
		device_status: 'Distribución de estado de dispositivos',
	},
	device: {
		total: 'Total',
		online: 'En línea',
		offline: 'Desconectado',
		channels: 'Canales',
		off_time: 'Desconectado desde',
		select_device: 'Seleccionar dispositivo',
	},
	daterange: {
		today: 'Hoy',
		'7d': 'Últimos 7 días',
		'30d': 'Últimos 30 días',
	},
	cust: {
		tab_portrait: 'Perfil',
		tab_precise:  'Tráfico preciso',
		tab_batch:    'Tráfico por lote',
		tab_realtime: 'Tiempo real',
		tab_consume:  'Consumo',
		tab_device:   'Dispositivo',
		filter: 'Filtrar',
		current_n_stores: '{{n}} tienda(s)',
		overview: 'Resumen',
		portrait_total: 'Perfiles totales',
		most_portrait: 'Perfil más común',
		unit_person: '',
		member_ratio: 'Miembros',
		gender_ratio: 'Género',
		age_ratio: 'Edad',
		age_x_gender: 'Edad × Género',
		age_x_identity: 'Edad × Identidad',
		member: 'Miembro',
		non_member: 'No miembro',
		male: 'Masc.',
		female: 'Fem.',
		precise_wip_title: 'Tráfico preciso',
		precise_wip_desc: 'Resumen + flujo + embudo + estancia + ranking (en curso)',
		mom: 'MoM',
		yoy: 'YoY',
		sub_flow: 'Flujo',
		sub_funnel: 'Embudo',
		sub_stay: 'Estancia',
		sub_rank: 'Ranking',
		gran_hour: 'Hora',
		gran_day: 'Día',
		flow_trend: 'Tendencia',
		kpi: {
			pass: 'Transeúntes',
			enter: 'Entradas',
			enter_rate: 'Tasa entrada',
			try: 'Pruebas',
			try_rate: 'Tasa prueba',
			member: 'Miembros',
			stay_avg: 'Estancia (min)',
			deal_rate: 'Tasa cierre',
			bind_device: 'Sin dispositivo',
			daily_avg: 'Media diaria',
			peak: 'Pico ({{date}})',
			valley: 'Valle ({{date}})',
		},
	},
	customer: {
		title: 'Análisis de clientes',
		date: 'Fecha',
		pass_count: 'Pasos cercanos',
		enter_count: 'Entradas',
		unit: 'personas',
		raw_response: 'Respuesta cruda',
		hourly_trend: 'Tendencia horaria de clientes',
	},
	member: {
		overview: 'Resumen',
		customer_list: 'Clientes',
		total: 'Miembros totales',
		new_count: 'Nuevos',
		return_count: 'Recurrentes',
		visit_count: 'Visitó {{count}} veces',
		last_visit: 'Última visita',
		start_from: 'Fecha de inicio',
		anonymous: 'Anónimo',
	},
	event: {
		range: 'Rango',
		total: '{{count}} eventos',
	},
	event_count: {
		all: 'Todos',
		wait: 'En espera',
		wait_handle: 'Pendiente acción',
		destroy: 'Cancelados',
		my: 'Mis eventos',
		my_appeal: 'Mis apelaciones',
		appeal_audit: 'Revisión apel.',
		recheck: 'Re-revisar',
	},
	live: {
		online_devices: 'Dispositivos',
		no_online: 'Sin dispositivos en esta tienda',
		play_live: 'Reproducir en vivo',
		get_play_token: 'Obtener token',
		play_token_for: 'Token · ',
		cloud_storage: 'Almacenamiento en la nube',
		web_limitation: 'Vídeo en vivo en web — estrategia',
		web_limitation_desc: 'La app actual usa el protocolo privado AYClient_SDK; la nueva estrategia usa auth.weburl de la plataforma abierta para obtener URL HFLV/HLS (reproducible en navegador, 1-2s de latencia).',
		token_only_note: 'play_token obtenido (API interna, para SDK nativo). auth.weburl requiere credenciales de plataforma abierta.',
		poc_title: 'PoC de compatibilidad HFLV',
		poc_intro: 'Verificar flv.js + navegador para HFLV',
		poc_intro_desc: 'Validar compatibilidad de navegador / Capacitor WebView con flujos de prueba públicos.',
		test_stream: 'Flujo de prueba',
		play: 'Reproducir',
		stop: 'Detener',
		reload: 'Recargar',
		logs: 'Registros',
		missing_sn: 'Falta SN del dispositivo, no reproducible',
	},
	scan: {
		browser_supported: 'Escaneo disponible en este navegador',
		browser_unsupported: 'Este navegador no permite escanear',
		browser_supported_desc: 'La web puede usar BarcodeDetector cuando el navegador lo permite; la app móvil usará el escáner nativo.',
		browser_unsupported_desc: 'Usa la app móvil o un navegador compatible con cámara y escaneo.',
		capacitor_plan: 'En iOS / Android se usará el escáner nativo; en web solo mostramos el estado de compatibilidad.',
		start_scan: 'Iniciar escaneo',
	},
	modules: {
		dashboard: 'Tablero',
		device: 'Dispositivo',
		store: 'Tienda',
		live: 'Vídeo en vivo',
		event: 'Centro de eventos',
		alert: 'Alerta',
		inspect: 'Inspección',
		patrol: 'Patrulla',
		leavepost: 'Fuera del puesto',
		customer: 'Análisis de clientes',
		traffic: 'Estadísticas de tráfico',
		heatmap: 'Mapa de calor',
		pos: 'Superposición POS',
		scan: 'Escanear',
		auth: 'Iniciar sesión',
		member: 'Miembros',
		evaluation: 'Evaluación',
		wechatvip: 'WeChat VIP',
		figurewarning: 'Alerta humana',
		university: 'Universidad Ulucu',
		staff: 'Personal',
		guard: 'Guardia',
		message: 'Mensajes',
		rewardpunish: 'Recompensas y sanciones',
		smartlistening: 'Escucha inteligente',
		cloudstorage: 'Almacenamiento en la nube',
		phonelive: 'Móvil en vivo',
		sharedevice: 'Dispositivos compartidos',
		datawarn: 'Alertas de datos',
		aipatrol: 'Inspección IA',
		reportaudit: 'Auditoría',
	},
	reportaudit: {
		title: 'Auditoría',
		tab: { audit: 'Auditoría', self: 'Autoevaluación' },
		filter: { store: 'Tienda', date: 'Fecha', status: 'Estado', template: 'Plantilla' },
		status: { pending: 'Pendiente', passed: 'Aprobado', rejected: 'Rechazado' },
	},
	changelog: {
		unread: 'Nuevo',
		load_more: 'Cargar más',
		no_more: '— No hay más —',
	},
	album: {
		empty: 'Sin capturas',
		local: 'Capturas locales',
		edit: 'Editar',
		delete: 'Eliminar',
		deleted: 'Eliminada(s)',
		delete_failed: 'Error al eliminar',
		select_first: 'Selecciona primero',
		selected_n: '{{n}} seleccionada(s)',
		confirm_delete: '¿Eliminar {{n}} foto(s) seleccionada(s)?',
		load_more: 'Cargar más',
		no_more: '— No hay más —',
	},
	aipatrol: {
		title: 'Inspección IA',
		banner_title: 'Inspección inteligente IA',
		banner_subtitle: 'Detección 24/7 — sin rondas manuales',
		unnamed_model: 'Modelo sin nombre',
		sec: { pic: 'IA de imagen', video: 'IA de vídeo', other: 'Otros' },
		app: {
			datacenter: 'Centro de datos',
			stats: 'Estadísticas',
			report: 'Informes',
			leavepost: 'Abandono puesto',
			gallery: 'Galería',
			alert: 'Alertas',
		},
		dc: {
			title: 'Centro de datos',
			fav: 'Favoritos',
			last7d: 'Últimos 7 días',
			all_stores: 'Todas las tiendas',
			all_models: 'Todos los modelos',
			load_more: 'Toca o desliza para más',
			no_more: '— No hay más —',
		},
		kpi: { stores: 'Tiendas activas', devices: 'Dispositivos' },
		alarm: {
			title_yesterday: 'Alarmas ayer',
			count_label: 'Cantidad',
			load_more: 'Cargar más',
			latest: 'Últimas alarmas',
		},
		stats: {
			title: 'Estadísticas',
			last7d: 'Últimos 7 días',
			all_tasks: 'Todas las tareas',
			all_stores: 'Todas las tiendas',
			all_users: 'Todos los inspectores',
			violation_total: 'Total infracciones',
			violation_type_count: 'Tipos infracción',
			store_total: 'Tiendas',
			patroller_count: 'Inspectores',
			report_submit_count: 'Informes enviados',
			trend: 'Tendencia tienda',
			dim_day: 'Día',
			dim_month: 'Mes',
			rank: 'Ranking infracciones',
			view_more: 'Ver más',
			col_item: 'Ítem',
			col_count: 'Cant.',
			col_stores: 'Tiendas',
		},
	},
	rep: {
		title: 'Informes',
		dash: '–',
		last_7d: 'últimos 7 días',
		today: 'hoy',
		no_content: 'Sin contenido',
		unit: { person: '', percent: '%', yuan: 'CNY' },
		cust: {
			title: 'Análisis de clientes',
			this_month: 'este mes',
			gdrs: 'Transeúntes',
			jdkl: 'Entradas',
			jzkl: 'Entradas precisas',
			jdzhl: 'Tasa de entrada',
			xsze: 'Ingresos',
		},
		youxun: {
			title: 'Youxun',
			alarm_count: 'Alarmas',
			most_store: 'Tienda principal',
			times: '',
			none: '—',
		},
		xdt: {
			title: 'Xundiantong',
			unit: '',
			examine_submit: 'Enviado',
			examine_waiting: 'Por revisar',
			examine_today: 'Tareas de hoy',
			inspect_submit: 'Auto-checks',
			inspect_waiting: 'Por revisar',
			inspect_today: 'Hoy',
			dj_handled: 'Resuelto',
			dj_waiting: 'Pendiente',
			dj_expired: 'Vencido',
		},
		event: {
			title: 'Eventos',
			total: 'Total',
			pending: 'Pendientes',
			key: 'Tipo principal',
			unit: '',
			none: '—',
		},
		editor: {
			btn: 'Reordenar',
			title: 'Reordenar y añadir',
			cancel: 'Cancelar',
			ok: 'Listo',
			advanced: 'Avanzado',
			shown: 'Módulos visibles',
			available: 'Módulos disponibles',
		},
		advanced: {
			title: 'Youxun avanzado',
			search_ph: 'Buscar modelo o ID',
			counter: 'Suscritos {{picked}} / {{total}}',
			saved: 'Guardado',
			save_failed: 'Error al guardar',
		},
	},
	mselect: {
		title: 'Elegir dispositivos',
		search_ph: 'Buscar dispositivo',
		counter: '{{online}} en línea · {{picked}} seleccionados',
		no_online: 'Sin dispositivos en línea',
		watch: 'Ver vídeo',
	},
	vfilter: {
		title: 'Filtrar',
		device: 'Dispositivos',
		has_dev: 'Con dispositivo',
		no_dev: 'Sin dispositivo',
		status: 'Estado',
		online: 'En línea',
		offline: 'Desconectado',
		fav_status: 'Favoritos',
		faved: 'Favorito',
		unfaved: 'No favorito',
		sort: 'Ordenar por',
		sort_create: 'Más recientes',
		sort_name: 'A → Z',
		reset: 'Restablecer',
		ok: 'Aplicar',
	},
	sov: {
		compare: 'vs',
		rank_title: 'Ranking de la tienda',
		b_avg: 'Media',
		exceed: 'supera al {{pct}}% de tiendas',
		avg: 'Media',
		settings_title: 'Ajustes de datos',
		selected_data: 'Métricas elegidas',
		selected_hint: 'arrastra para ordenar',
		done: 'Listo',
		saved: 'Guardado',
		save_failed: 'Error al guardar',
		cat: {
			business: 'Negocio',
			traffic: 'Tráfico',
			event: 'Gestión',
		},
		p: {
			hour: 'H',
			day: 'D',
			week: 'Sem',
			month: 'Mes',
			quarter: 'Trim',
		},
		t: {
			jzkl: 'Entradas precisas',
			gdrs: 'Transeúntes',
			gdrs_f: 'Transeúntes (F)',
			jdzhl: 'Tasa de entrada',
			xfds: 'Pedidos',
			xsze: 'Ingresos',
			cjl: 'Tasa de cierre',
			sjzs: 'Eventos',
			dclsjs: 'Eventos pendientes',
			zkl: 'Tráfico total',
			jtlsc: 'Estancia (min)',
			kdj: 'Ticket medio',
			ldl: 'Artículos/pedido',
		},
	},
	native: {
		common: {
			all: 'Todos',
			back: 'Volver',
			cancel: 'Cancelar',
			clear: 'Borrar',
			complete: 'Completar',
			confirm: 'Confirmar',
			copy: 'Copiar',
			date: 'Fecha',
			default: 'Predeterminado',
			details: 'Detalles',
			edit: 'Editar',
			filter: 'Filtrar',
			from_high_to_low: 'De mayor a menor',
			level: 'Nivel',
			no_content: 'Sin contenido',
			no_data: 'Sin datos',
			online: 'En línea',
			offline: 'Sin conexión',
			operation_failed: 'Operación fallida',
			organization: 'Organización',
			people: 'Personas',
			phone: 'Telefono',
			pcs: 'uds.',
			picture: 'Imagen',
			refresh: 'Actualizar',
			remove_picture: 'Quitar imagen',
			reset: 'Restablecer',
			save: 'Guardar',
			search: 'Buscar',
			search_by_store_name: 'Buscar por nombre de tienda',
			search_history: 'Historial de búsqueda',
			store: 'Tienda',
			submit: 'Enviar',
			view_all: 'Ver todo',
			video: 'Vídeo',
			all_stores: 'Todas las tiendas',
			all_status: 'Todos los estados',
			all_tasks: 'Todas las tareas',
			all_executors: 'Todos los ejecutores',
		},
		settings: {
			title: 'Ajustes',
			modify_password: 'Modificar contraseña',
			language_setting: 'Ajuste de idioma',
			clear_cache: 'Borrar caché',
			clear_cache_confirm: '¿Borrar caché?',
			about_us: 'Acerca de nosotros',
			logout: 'Cerrar sesión',
			old_password: 'Contraseña anterior',
			new_password: 'Nueva contraseña',
			confirm_password: 'Confirmar contraseña',
		},
		profile: {
			my_album: 'Mi álbum',
			watch_history: 'Historial de visualización',
			online_repair: 'Reparación en línea',
			repair_record: 'Registro de reparaciones',
			setting: 'Ajustes',
		},
		home: {
			title: 'Inicio',
			latest_news: 'Últimas noticias',
			assessment: 'Evaluación',
			today: 'Hoy',
			assessment_empty: 'Sin contenido',
			submitted: 'Enviar evaluación',
			waiting_approve: 'Pendiente de aprobación',
			event: 'Evento',
			recent_7_days: 'Últimos 7 días',
			events: 'Eventos',
			pending_events: 'Eventos por procesar',
			key_type: 'Tipo de evento clave',
			ranking: 'Orden y visualización',
			organization: 'Organización',
			message: 'Centro de mensajes',
			system_message: 'Mensaje del sistema',
			event_message: 'Mensaje de evento',
			evaluation_message: 'Mensaje de evaluación',
			store_inspection_message: 'Mensaje de inspección de tienda',
			no_new_message: 'Sin mensajes nuevos',
			new_message: 'Mensaje nuevo',
			no_latest_news: 'Sin noticias recientes',
			last_update: 'Última actualización:',
			no_data_last_2_days: 'Sin datos en los últimos 2 días~',
			management: 'Gestión',
			statistics: 'Estadísticas',
			report: 'Informe',
			my_assessment: 'Mi evaluación',
			audits: 'Auditorías',
			draft_box: 'Borradores',
			report_status: 'Estado del informe',
			template: 'Plantilla',
			pending: 'Pendiente',
			to_be_accepted: 'Por aceptar',
			processed: 'Procesado',
			expired: 'Caducado',
			deleted: 'Eliminado',
			total_events: 'Eventos totales',
			event_types: 'Tipos de evento',
			message_content_aria: 'Contenido del mensaje',
			message_aria: 'Mensaje',
			create_event: 'Crear evento',
			submit: 'Enviar',
			select_store: 'Seleccionar tienda',
			please_choose_store: 'Seleccione una tienda',
			please_choose_event_type: 'Seleccione tipo de evento',
			event_scoring: 'Puntuación del evento',
			priority: 'Prioridad',
			assign_to: 'Asignar a',
			follower: 'Seguidor',
			remarks_placeholder: 'Observaciones, máximo 3000 caracteres',
			add_3_pictures: 'Añadir 3 imágenes como máximo',
			confirm: 'Confirmar',
			select_all: 'Seleccionar todo',
			store_name: 'Nombre de la tienda',
			name: 'Nombre',
			please_input_key_words: 'Introduzca palabras clave',
			please_input_key_words_title: 'Introduzca palabras clave',
			choose_store_required: 'Seleccione una tienda',
			choose_event_type_required: 'Seleccione tipo de evento',
			priority_source_pending: 'La prioridad aún no está lista',
			scoring_required: 'Seleccione puntuación del evento',
			property_required: 'Seleccione elemento de puntuación',
			choose_assignor_required: 'Seleccione un responsable',
			picture_required: 'Seleccione o añada una imagen',
			event_created: 'Creado correctamente',
			choose_store_first: 'Seleccione primero una tienda',
			please_select_assignor: 'Seleccione un responsable',
			please_select_follower: 'Seleccione seguidor',
			select_assignor: 'Seleccionar responsable',
		},
		application: {
			title: 'Aplicaciones',
			display_title: 'Orden y visualización',
			display_subtitle: 'Módulo de visualización de la página de aplicaciones',
			fixed: 'Fijado',
			saved: 'Visualización de aplicaciones guardada',
			reset_done: 'Orden predeterminado restaurado',
			last_visible: 'Mantén al menos una aplicación visible',
			move_up: 'Subir',
			move_down: 'Bajar',
			show: 'Mostrar',
			hide: 'Ocultar',
			function_intro: 'Introducción de función',
			permission_denied: 'No tienes permiso para usar este módulo.',
			groups: {
				store: 'Digitalización de tienda',
				standard: 'Gestión estandarizada',
				marketing: 'Marketing inteligente',
				data: 'Centro de datos',
			},
			items: {
				customer_flow_analysis: 'Análisis de flujo de clientes',
				traffic_flow: 'Flujo de tráfico',
				heat_map: 'Mapa de calor',
				event: 'Evento',
				shake_inspection: 'Inspección rápida',
				off_duty_patro: 'Patrulla fuera de puesto',
				timed_inspection: 'Inspección programada',
				timed_snapshot_inspection: 'Inspección de captura programada',
				assessment: 'Evaluación',
				qr_code_scan_superposition: 'Superposición por escaneo QR',
				intelligent_attendance: 'Asistencia inteligente',
				reward_punish: 'Premios y sanciones',
				smart_listening: 'Escucha inteligente',
				shopping_guide: 'Guía de compras',
				intelligent_classroom: 'Aula inteligente',
				customer_flow_alert: 'Alerta de flujo de clientes',
				ranking_display: 'Orden y visualización',
				phone_live: 'Directo móvil',
				smart_marketing: 'Marketing inteligente',
				data_center: 'Centro de datos',
				cloud_storage: 'Almacenamiento en la nube',
			},
		},
		store: {
			device_list: 'Lista de dispositivos',
			data: 'Datos',
			access_camera: 'Acceder a la cámara',
			repair_record: 'Registro de reparaciones',
			store_creation_time: 'Fecha de creación de la tienda',
			camera_setting: 'Ajustes de cámara',
			device_layout_preview: 'Vista previa',
			device_layout_list: 'Lista',
			device_is_offline: 'Dispositivo sin conexión',
			offline_time: 'Hora sin conexión',
			offline_duration: 'Duración sin conexión',
			setting_unavailable: 'Este ajuste aún no está disponible en web.',
			camera_name: 'Nombre de la cámara',
			cloud_storage: 'Almacenamiento en la nube',
			local_storage: 'Almacenamiento local',
			connect_other_wifi: 'Conectar a otro Wi-Fi',
			no_longer_use: 'Dejar de usar',
			connect_camera_to_store: 'Conecta la cámara a tu tienda',
			compared_previous: 'Comparado con el periodo anterior',
			events: 'Eventos',
			events_to_be_processed: 'Eventos por procesar',
			data_ranking: 'Ranking de datos de la tienda',
			store_data_setting: 'Ajuste de datos de la tienda',
			data_selected_hint: 'Datos seleccionados(Mantén pulsado y arrastra para ajustar el orden)',
			manage_data: 'Gestionar datos',
			max_metrics: 'Selecciona hasta {{count}} métricas',
			keep_one_metric: 'Mantén al menos una métrica seleccionada',
			chart_visibility: 'Visibilidad del gráfico',
			average: 'Promedio',
			compared_previous_range: '(Comparado con el periodo anterior{{range}})',
			ranking_detail_with_unit: 'Promedio empresarial {{average}}{{unit}}, supera al {{exceed}}% de tiendas',
			period_hour: 'Hora',
			period_day: 'Día',
			period_week: 'Semana',
			period_month: 'Mes',
			period_quarter: 'Trimestre',
			full_storage: 'Almacenamiento completo',
			mobile_detection_storage: 'Almacenamiento por detección de movimiento',
			set_storage_schedule: 'Configurar horario de almacenamiento',
			entry_number: 'Número de entradas',
			pieces: '{{count}} uds.',
			ranking_detail: 'Promedio empresarial {{average}} uds., supera al {{exceed}} de tiendas',
			cloud_storage_banner_auto_detect: 'Detección automática, almacenamiento en la nube',
			cloud_storage_banner_look_back: 'Consulta en cualquier momento',
			cloud_storage_banner_encryption: 'Cifrado estricto, seguridad',
			cloud_storage_unavailable_line1: 'El servicio de almacenamiento en la nube',
			cloud_storage_unavailable_line2: 'aún no está disponible.',
			contact_administrator: 'Contacta a tu administrador.',
			memory_card_recording: 'Activar grabación en tarjeta de memoria',
			memory_card_type: 'Seleccionar tipo de tarjeta de memoria',
			internal_storage_space: 'Espacio de almacenamiento interno',
			storage_available: 'Disponible {{value}}',
			storage_total: 'Total {{value}}',
			format_memory_card: 'Formatear tarjeta de memoria',
			storage_status_normal: 'Normal',
			memory_card_format_hint: 'Después de formatear, parte del espacio de la tarjeta se usará para archivos del sistema y la capacidad restante mostrada puede ser menor que el tamaño real.',
			memory_card_non_standard_tip: 'Consejo: esta tarjeta de memoria no es estándar. Usa una tarjeta estándar para proteger tus datos.',
		},
		repair: {
			record: 'Registro de reparaciones',
			date_range: 'Rango de fechas',
			status_submitted: 'Enviado',
			status_processing: 'En proceso',
			repair_no: 'N.º de reparación',
			select_store: 'Seleccionar tienda',
			contact_person: 'Persona de contacto',
			contact_number: 'Número de contacto',
			tel: 'Tel.',
			store_prefix: 'Tienda',
			add_picture: 'Anadir imagen',
			fault_tip: 'Describe la falla y los pasos relacionados para que nuestro ingeniero pueda resolverla lo antes posible.',
			pictures_tip: 'Sube imagenes relacionadas como referencia para resolver el problema con eficiencia.',
			fault_description: 'Descripción de la falla',
			submission_time: 'Hora de envío',
			images: 'Imágenes',
			no_images: 'Sin imágenes',
		},
		snapshot: {
			timed_snapshot_inspection: 'Inspeccion de captura programada',
			inspection_statistics: 'Estadisticas de inspeccion',
			inspection_data: 'Datos de inspeccion',
			inspection_task: 'Tarea de inspeccion',
			create_inspection: 'Crear inspeccion',
			store_data_statistics: 'Estadisticas de tienda',
			executor_statistics: 'Estadisticas de ejecutor',
			start_date: 'Fecha inicial',
			end_date: 'Fecha final',
			load_failed: 'Error al cargar',
			apac_only: 'La inspeccion de captura programada solo esta conectada para APAC.',
			ranking_all_stores: 'Ranking de todas las tiendas',
			total_violations: 'Violaciones totales',
			all_planned_screenshot: 'Capturas planificadas',
			current_screenshot: 'Capturas actuales',
			current_processed: 'Procesadas actuales',
			overdue_unprocessed: 'Vencidas sin procesar',
			all_unprocessed: 'Todas sin procesar',
			maximum_violations: 'Violaciones maximas',
			minimum_violations: 'Violaciones minimas',
			ranking: 'Ranking',
			violation_items_ranking: 'Ranking de elementos con violación',
			items_name: 'Nombre del elemento',
			account: 'Cuenta',
			full_name_role: 'Nombre completo (rol)',
			to_be_processed: 'Por procesar',
			processed: 'Procesado',
			rank: 'Rango',
			task_status: 'Estado de tarea',
			enabled: 'Habilitada',
			disabled: 'Cerrada',
			plan_opened_success: 'Plan abierto correctamente',
			plan_closed_success: 'Plan cerrado correctamente',
			plan_status_failed: 'No se pudo actualizar el estado del plan',
			delete_task: 'Eliminar tarea',
			delete_success: 'Eliminado correctamente',
			delete_failed: 'Error al eliminar',
			today_screenshots: 'Capturas de hoy',
			today_processed: 'Procesadas hoy',
			total_unprocessed: 'Total sin procesar',
			total_unqualified: 'Total no calificadas',
			task_store: 'Tienda de tarea',
			stores_suffix: 'Tiendas',
			executor: 'Ejecutor',
			people_suffix: 'Personas',
			task_time: 'Tiempo de tarea',
			execution_cycle: 'Ciclo de ejecucion',
			task_name: 'Nombre de tarea',
			detail_information: 'Informacion detallada',
			execution_date: 'Fecha de ejecucion',
			execution_month: 'Mes de ejecucion',
			assessment_template: 'Plantilla de evaluacion',
			select_template: 'Seleccionar plantilla',
			store: 'Tienda',
			select_executor: 'Seleccionar ejecutor',
			device_point: 'Dispositivo',
			select_device: 'Seleccionar dispositivo',
			execution_time: 'Hora de ejecucion',
			add_time: 'Agregar hora',
			validation_template: 'Selecciona una plantilla de evaluacion',
			save_success: 'Guardado correctamente',
			save_failed: 'Error al guardar',
			qualified: 'Calificada',
			unqualified: 'No calificada',
			process_success: 'Procesado correctamente',
			process_failed: 'Error al procesar',
			mon: 'Lun',
			tues: 'Mar',
			wed: 'Mie',
			thur: 'Jue',
			fri: 'Vie',
			sat: 'Sab',
			sun: 'Dom',
			violation_numbers: 'Número de violaciones',
			percentage: 'Porcentaje',
			daily_violation_item: 'Tendencia diaria de violaciones (por elemento)',
			daily_violation_store: 'Tendencia diaria de violaciones (por tienda)',
		},
		evaluation: {
			management: 'Gestion',
			store: 'Tienda',
			title: 'Evaluación',
			assessment_today: 'Evaluación de hoy',
			assigned_to_me: 'Asignado a mí',
			remote_assessment: 'Evaluación remota',
			onsite_assessment: 'Evaluación en sitio',
			my_task: 'Mi tarea',
			ranking: 'Ranking',
			task_progress: 'Progreso de tareas:',
			by_score: 'Por puntuacion',
			by_store: 'Por tienda',
			select_task: 'Seleccionar tarea',
			select_store: 'Seleccionar tienda',
			select_user: 'Seleccionar usuario',
			select_stores_count: 'Seleccionar({{count}}) tiendas',
			select_tasks_count: 'Seleccionar({{count}}) tareas',
			search_store: 'Buscar tienda',
			deselect_all: 'Deseleccionar todo',
			keyword_placeholder: 'Introduce una palabra clave',
			user_keyword_placeholder: 'Introduce palabras clave...',
			expired_tasks: 'Expired Tasks',
			no_tasks_in_progress: 'No tasks in progress',
			select_date: 'Select Date',
			today: 'Today',
			recent_7_days: 'Recent 7 Days',
			recent_30_days: 'Recent 30 Days',
			recent_90_days: 'Recent 90 Days',
			recent_180_days: 'Recent 180 Days',
			customize: 'Customize',
			start_date: 'Start Date',
			end_date: 'End Date',
			select_user_count: 'Select({{count}})User',
			select_templates_count: 'Select({{count}})Templates',
			please_select: 'Please Select',
			please_input: 'Please input',
			please_input_keywords: 'Please Input Key Words',
			store_name: 'Store Name',
			name: 'Name',
			select_all: 'Select All',
			location_permission: 'Debes activar el permiso de ubicacion para obtener tiendas cercanas',
			reviewer: 'Revisor',
			submitter: 'Remitente',
			report: 'Report',
			my_assessment: 'My Assessment',
			audits: 'Audits',
			draft_box: 'Draft Box',
			date: 'Date',
			report_status: 'Report Status',
			template: 'Template',
			assessment_details: 'Assessment Details',
			assessment_time: 'Assessment Time',
			score: 'Score',
			assessment_task: 'Assessment Task',
			source: 'Source',
			assessment_content: 'Assessment Content',
			filter_full_score_item: 'Filter Full Score Item',
			standard: 'Standard',
			qualified: 'Qualified',
			unqualified: 'Unqualified',
			passed: 'Passed',
			failed: 'Failed',
			remarks: 'Remarks',
			no_picture: 'No picture',
			no: 'No',
		},
		inspect: {
			empty: 'Aun no has agregado un plan de inspeccion de tienda~',
			add_plan: 'ANADIR PLAN',
			title: 'Inspección programada',
			add_title: 'Agregar plan',
			plan: 'Plan',
			plan_name: 'Nombre del plan',
			select_store: 'Seleccionar tienda',
			select_device: 'Seleccionar equipo',
			equipment_location: 'Ubicacion del equipo',
			store_inspection_time: 'Hora de inspeccion',
			set_time: 'Definir hora de inspeccion',
			submit_plan: 'Enviar plan',
			confirm: 'Confirmar',
			cancel: 'Cancelar',
			select_all: 'Seleccionar todo',
			store_name: 'Nombre de tienda',
			equipment_name: 'Nombre del equipo',
			search_keywords: 'Introduce palabras clave',
			equipment_search: 'Buscar equipo',
			no_stores: 'Sin tiendas',
			no_devices: 'Sin equipos',
			store_count: 'Numero de tiendas inspeccionadas',
			stores: 'Tiendas',
			inspection_time: 'Hora de inspeccion',
			running_state: 'estado de ejecucion',
			executing: 'Ejecutando',
			closed: 'Cerrado',
			detail_title: 'Detalle del plan de inspeccion de tienda',
			update_time: 'Hora de actualizacion',
			enabled: 'Habilitado',
			off_state: 'Desactivado',
			intelligent: 'Inteligente',
			time: 'Hora',
			no_data: 'Sin datos',
			refresh: 'Actualizar',
			plan_opened_success: 'Plan habilitado correctamente',
			plan_closed_success: 'Plan cerrado correctamente',
			plan_status_failed: 'No se pudo actualizar el estado del plan',
			picture_preview: 'Vista previa de imagen',
			picture_load_failed: 'No se pudieron cargar las imagenes',
			create_event: 'Crear evento',
			download_picture: 'Descargar imagen',
			intelligent_options: 'Opciones inteligentes',
			intelligent_options_title: 'Selecciona opciones inteligentes para la inspeccion de tienda',
			intelligent_option_roughly: 'Este lugar cumple aproximadamente',
			intelligent_options_learning: 'Mas informacion sobre opciones inteligentes...',
			intelligent_options_tip: 'Consejo: despues de activar opciones inteligentes, las imagenes de inspeccion de tienda que no cumplan las opciones se listaran por separado. Sin embargo, si la camara se desvia, el resultado puede ser impreciso o invalido. En ese caso, las opciones inteligentes de la ubicacion se pueden restablecer.',
			choose_later: 'Elegir mas tarde',
			device_context_missing: 'La informacion del dispositivo no esta disponible',
			message_context_missing: 'La informacion del mensaje no esta disponible',
			picture_unavailable: 'La imagen no esta disponible',
			add_success: 'Plan agregado correctamente',
			delete: 'Eliminar',
			delete_confirm_title: 'Eliminar plan',
			delete_confirm_body: 'Eliminar este plan de inspeccion programada?',
			delete_success: 'Plan eliminado',
			delete_failed: 'Error al eliminar',
			load_failed: 'Error al cargar planes de inspeccion',
			submit_failed: 'Error al enviar',
			validation_plan_name: 'Introduce el nombre del plan',
			validation_store: 'Selecciona una tienda',
			validation_device: 'Selecciona equipo',
			validation_time: 'Selecciona una hora de inspeccion',
			validation_user: 'Falta el ID del usuario actual',
			validation_item: 'Los metadatos del item de inspeccion estan incompletos',
			hour: 'Hora',
			minute: 'Minuto',
			time_slot_1: 'Selecciona la primera hora de inspeccion',
			time_slot_2: 'Selecciona la segunda hora de inspeccion',
			time_slot_3: 'Selecciona la tercera hora de inspeccion',
			time_slot_4: 'Selecciona la cuarta hora de inspeccion',
			time_slot_5: 'Selecciona la quinta hora de inspeccion',
			time_slot_6: 'Selecciona la sexta hora de inspeccion',
			time_slot_7: 'Selecciona la septima hora de inspeccion',
			time_slot_8: 'Selecciona la octava hora de inspeccion',
			time_slot_9: 'Selecciona la novena hora de inspeccion',
			time_slot_10: 'Selecciona la decima hora de inspeccion',
		},
	},
};
